import { PHONE_PATTERN } from '../../../utils/common';
import { FormInput } from '../../../common/components';
import { useContext } from 'react';
import { UserDetailContext, UserDetailContextProps } from '../../../context/userDetail/userDetailContext';

type YourInfoBlockProps = {};

export const YourInfoBlock = (props: YourInfoBlockProps) => {
  const { userDetail } = useContext<UserDetailContextProps>(UserDetailContext);

  return (
    <>
      <div className='formRowWrapper withContactDetails'>
        <div className='raisedByInfo'>{`Moving premises notification raised by - ${userDetail.emailAddress}`}</div>

        <div className='row contactDetailsInfo'>
          <div className='contactDetailsText'>Contact name*</div>
          <div className='contactDetailsInput'>
            <FormInput
              name='yourContactName'
              disabled={false}
              params={{
                required: true,
              }}
            />
          </div>
        </div>

        <div className='row contactDetailsInfo'>
          <div className='contactDetailsText'>Contact number*</div>
          <div className='contactDetailsInput'>
            <FormInput
              name='yourPhoneNumber'
              disabled={false}
              params={{
                required: true,
                pattern: {
                  value: PHONE_PATTERN,
                  message: 'Please provide a valid phone number without spaces',
                },
              }}
            />
          </div>
        </div>
      </div>
    </>
  );
};
